module.exports = __webpack_public_path__ + "images/dealerleasing_small1f5d5e376fc478172da718e22509599b.png";